import * as React from 'react'
import { Card, CardContent, CardActionArea } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import {
  ActionFooter,
  Content,
  ResourcePlayer,
  LockedResource,
} from 'components/pages/posts'
import { Router } from 'routes'
import { useCurrentUser } from 'utils/context/UserContext'

export default function PostCard({
  post,
  style,
  isArtistPage = false,
  onDeleteComplete = () => {},
}) {
  const s = useStyle({})
  const { currentUser } = useCurrentUser()

  const onRoutePost = e => {
    Router.pushRoute(isArtistPage ? 'artistPost' : 'post', { id: post.id })
  }

  const onRouteSubscription = () => {
    !isStopSubscription &&
      Router.pushRoute('artistSubscribe', { name: post.artist.accountId })
  }

  const isStopSubscription = post.artist.subscription?.status === 'stopped'
  const isAccessible =
    !post.isPremium ||
    !!post.artist.patron ||
    currentUser?.uid === post.artistId

  return (
    <Card style={style}>
      {isAccessible ? (
        <ResourcePlayer
          square
          resource={post.resource}
          resourceType={post.resourceType}
        />
      ) : (
        <LockedResource post={post} onClick={onRouteSubscription} />
      )}
      <CardActionArea
        onClick={isAccessible ? onRoutePost : onRouteSubscription}
        component="a"
      >
        <CardContent classes={{ root: s.content }}>
          <Content
            post={post}
            short
            canEdit={isArtistPage}
            onDeleteComplete={onDeleteComplete}
          />
        </CardContent>
        <ActionFooter post={post} />
      </CardActionArea>
    </Card>
  )
}

const useStyle = makeStyles({
  content: {
    display: 'flex',
    flexFlow: 'column',
    padding: '16px 16px 0 16px',
  },
})
